import { render, staticRenderFns } from "./ucmenu.vue?vue&type=template&id=b751bdb4&scoped=true"
import script from "./ucmenu.vue?vue&type=script&lang=js"
export * from "./ucmenu.vue?vue&type=script&lang=js"
import style0 from "./ucmenu.vue?vue&type=style&index=0&id=b751bdb4&prod&lang=css"
import style1 from "./ucmenu.vue?vue&type=style&index=1&id=b751bdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b751bdb4",
  null
  
)

export default component.exports